import { PublicHeader } from "@/components/PublicHeader";
import { ContactForm } from '@/components/ContactForm';
import { LandingFooter } from '@/components/landing/LandingFooter';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { useEffect, useState } from 'react';
import { LeadFormModal } from '@/components/LeadFormModal';

const PublicContact = () => {
  const [showLeadForm, setShowLeadForm] = useState(false);

  useEffect(() => {
    document.title = 'Contact Us | CampChef Pro - Let\'s Talk About Your Camp Kitchen';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Have questions about CampChef Pro? Our team is ready to help you streamline your camp kitchen operations. Request a demo today.');
    }
  }, []);

  return <div className="min-h-screen bg-sand">
      <PublicHeader />
      
      {/* Hero Section */}
      <section className="relative bg-midnight-green overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&q=80')`
        }} />
          <div className="absolute inset-0 bg-gradient-to-r from-midnight-green/95 via-midnight-green/85 to-midnight-green/70" />
        </div>

        {/* Content */}
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 bg-copper/10 border border-copper/20 rounded-full px-4 py-2 mb-6">
              <Mail className="h-4 w-4 text-copper" />
              <span className="text-copper text-sm font-semibold">We're Here to Help</span>
            </div>
            <h1 className="font-playfair text-5xl md:text-6xl font-bold text-ivory mb-6">
              Get in Touch with CampChef Pro
            </h1>
            <p className="font-inter text-xl text-ivory/80 leading-relaxed">
              Questions about our platform? Ready for a demo? Our team is standing by to help you transform your camp kitchen operations.
            </p>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-sand to-transparent" />
      </section>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="max-w-3xl mx-auto">
          <div className="mb-8 text-center">
            <h2 className="font-playfair text-3xl font-bold text-midnight-green mb-3">
              Send Us a Message
            </h2>
            <p className="font-inter text-gray-600">
              Fill out the form below and we'll get back to you within 24 hours.
            </p>
          </div>
          <ContactForm />
        </div>

        {/* Call-to-Action Banner */}
        <div className="mt-20 bg-gradient-to-r from-midnight-green to-midnight-green/90 rounded-2xl p-12 text-center relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 left-10 w-32 h-32 bg-copper rounded-full blur-3xl" />
            <div className="absolute bottom-10 right-10 w-40 h-40 bg-copper rounded-full blur-3xl" />
          </div>
          <div className="relative">
            <h3 className="font-playfair text-3xl font-bold text-ivory mb-4">
              Ready to Transform Your Camp Kitchen?
            </h3>
            <p className="font-inter text-ivory/80 text-lg mb-8 max-w-2xl mx-auto">
              Join hundreds of camp directors and kitchen managers already using CampChef Pro to streamline operations and reduce food costs.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button onClick={() => setShowLeadForm(true)} className="inline-flex items-center justify-center px-8 py-4 bg-copper hover:bg-copper/90 text-ivory font-semibold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl">
                Request Demo
              </button>
              <a href="/pricing" className="inline-flex items-center justify-center px-8 py-4 bg-white/10 hover:bg-white/20 text-ivory font-semibold rounded-lg border border-ivory/20 transition-all duration-300">
                View Pricing
              </a>
            </div>
          </div>
        </div>
      </main>

      <LandingFooter />
      
      <LeadFormModal
        open={showLeadForm}
        onClose={() => setShowLeadForm(false)}
        preselectedPackage="not_sure"
        sourcePage="contact_page_cta"
      />
    </div>;
};
export default PublicContact;